<script setup lang="ts">
import FooterInfo from '@/components/Footer/footer-info/FooterInfo.vue'
import FooterLinks from '@/components/Footer/footer-links/FooterLinks.vue'
</script>

<template>
  <footer class="footer">
    <div class="footer__container">
      <footer-links />
      <footer-info />
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: var(--ui-grey);

  &__container {
    width: 100%;
    padding: 0 20px;
  }

  @include media('>desktop-mini') {
    &__container {
      padding: 0 calc((100% - 1200px) / 2);
    }
  }
}
</style>
